<script lang="ts">
	//UI
	import { MBRLink } from "@hitit/new_ui";
	//Utils
	import { t } from "@hitit/hub/src/stores";
	import { pick } from "svelte-routing/src/utils";
	import { link } from "svelte-routing";
	import { globalHistory } from "svelte-routing/src/history";
	//Props
	export let linkClickAfterHanlder = () => {};
	//Types
	//Constants
	const activeCicleFill = "#6591fa";
	const deActiveCircleFill = "#6d6f76";
	//Variables
	let path = window.location.pathname;
	$: navItems = [
		{
			label: $t("hub.store.title"),
			route: "/store/*",
			to: "/store",
		},
		{
			label: $t("mbr.users.title"),
			route: "/users/*",
			to: "/users",
		},
		{
			label: $t("mbr.setting.title"),
			route: "/hubsetting/*",
			to: "/hubsetting/faq",
		}
	];
	$: routes = navItems?.map((i) => ({ path: i.route })) || [];
	$: matched = pick(routes, path);
	$: matchedRoutePath = matched?.route.path;

	//Functions

	//Do
	globalHistory.listen((v) => (path = v.location.pathname));

</script>

<div class="container">
	{#each navItems as item}
		<a
			on:click={linkClickAfterHanlder}
			use:link
			href={item.to}
			class="nav-item"
			class:active={matchedRoutePath === item.route}>
			<span class="icon">
				<MBRLink
					circleFill={matchedRoutePath === item.route ? activeCicleFill : deActiveCircleFill} />
			</span>
			<span class="label"> {item.label} </span>
		</a>
	{/each}
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		width: 100%;
		padding: 0px 20px;
		align-items: center;
		gap: 10px;
		.nav-item {
			display: flex;
			align-items: center;
			height: 40px;
			box-sizing: border-box;
			gap: 10px;
			width: 100%;
			padding: 10px 20px;
			background-color: #333338;
			border: 0;
			border-radius: 20px;

			&:hover {
				cursor: pointer;
			}
			&.active {
				.label {
					font-weight: 500;
					color: white;
				}
			}
			.icon {
				width: 20px;
				height: 19px;
			}
			.label {
				transition: color 0.5s;
				color: #bcbfc3;
			}
		}
	}
	@include DesktopSize {
		.container {
			.nav-item {
				padding: 15px 29px;
				height: 55px;
				gap: 15px;
				border-radius: 27.5px;
				.icon {
					width: 25px;
					height: 25px;
				}
				.label {
					font-size: 1.25rem;
				}
			}
		}
	}

</style>
